class WtrMobileBuy extends HTMLElement {
  connectedCallback() {
    this.root = document.querySelector('.main-product--root');
    this.form = this.root?.querySelector('.main-product--form');
    this.mainButton = this.form?.querySelector('.product-buy-buttons--primary');
    if (!this.mainButton) return;
    this.sizeSelect = this.querySelector('select');
    this.button = this.querySelector('button');
    this.chosen = !this.sizeSelect || this.dataset.explicitVariant === 'true' || this.dataset.allSoldOut === 'true';
    this.mainVisible = false;
    this.mobile = matchMedia('(max-width:767px)');
    this.controller = new AbortController();
    const signal = this.controller.signal;
    if (!this.chosen) this.sizeInputs().forEach(input => { input.checked = false; });
    this.form.addEventListener('change', event => {
      if (event.target.matches('input[data-option-name="size"]')) {
        this.chosen = true;
        this.pending = true;
        this.sync();
      }
    }, {capture:true, signal});
    this.form.addEventListener('submit', event => {
      if (!this.chosen || this.pending) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.askForSize();
      }
    }, {capture:true, signal});
    this.form.addEventListener('click', event => {
      if (!this.chosen && event.target.closest('.product-buy-buttons--primary')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.askForSize();
      }
    }, {capture:true, signal});
    this.sizeSelect?.addEventListener('change', () => {
      const input = this.sizeInputs().find(input => input.value === this.sizeSelect.value);
      if (!input || this.pending) return;
      if (input.checked) { this.chosen = true; this.sync(); }
      else input.click();
    }, {signal});
    this.button.addEventListener('click', () => {
      if (!this.chosen) {
        this.sizeSelect?.focus();
        if (this.sizeSelect?.showPicker) this.sizeSelect.showPicker();
        else this.askForSize();
      } else if (!this.mainButton.disabled && !this.pending) this.mainButton.click();
    }, {signal});
    this.onVariant = () => { this.pending = false; this.sync(); };
    window.addEventListener(`theme:product:${this.root.dataset.productId}:variantChanged`, this.onVariant, {signal});
    this.intersection = new IntersectionObserver(entries => {
      this.mainVisible = entries[0].isIntersecting;
      this.sync();
    }, {threshold:0.1});
    this.intersection.observe(this.mainButton);
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.form, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-busy']});
    this.drawerObserver = new MutationObserver(() => this.sync());
    const viewport = document.querySelector('.layout--viewport');
    if (viewport) this.drawerObserver.observe(viewport, {attributes:true,attributeFilter:['data-drawer-status']});
    this.mobile.addEventListener('change', () => this.sync(), {signal});
    this.sync();
  }
  sizeInputs() { return [...this.form.querySelectorAll('input[data-option-name="size"]')]; }
  askForSize() {
    const group = this.sizeInputs()[0]?.closest('.product-options--option');
    if (!group) return;
    group.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    group.classList.add('wtr-size-error');
    this.sizeInputs()[0]?.focus({preventScroll:true});
  }
  sync() {
    if (!this.form) return;
    const busy = this.pending || this.mainButton.getAttribute('aria-busy') === 'true' || this.form.querySelector('product-options-element[aria-busy="true"]');
    const selected = this.sizeInputs().find(input => input.checked);
    if (this.sizeSelect) {
      this.sizeSelect.disabled = !!busy;
      this.sizeSelect.value = this.chosen && selected ? selected.value : '';
    }
    const group = this.sizeInputs()[0]?.closest('.product-options--option');
    group?.toggleAttribute('data-wtr-size-needed', !this.chosen);
    if (this.chosen) group?.classList.remove('wtr-size-error');
    let label = this.chosen ? this.mainButton.querySelector('.product-buy-buttons--cta-text')?.textContent.trim() || this.dataset.add : this.dataset.choose;
    if (this.button.textContent !== label) this.button.textContent = label;
    this.button.disabled = !!busy || (this.chosen && this.mainButton.disabled);
    const mainText = this.mainButton.querySelector('.product-buy-buttons--cta-text');
    if (!this.chosen && mainText && mainText.textContent !== this.dataset.choose) mainText.textContent = this.dataset.choose;
    const drawerClosed = document.querySelector('.layout--viewport')?.dataset.drawerStatus === 'closed';
    this.hidden = !this.mobile.matches || this.mainVisible || !drawerClosed;
    document.body.dataset.wtrBuyVisible = String(!this.hidden);
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.intersection?.disconnect();
    this.observer?.disconnect();
    this.drawerObserver?.disconnect();
    delete document.body.dataset.wtrBuyVisible;
  }
}
if (!customElements.get('wtr-mobile-buy')) customElements.define('wtr-mobile-buy', WtrMobileBuy);
